import Image from '@components/ui/image'
import { Heading, Text } from '@components/ui/typography'
import { urlFor } from '@lib/sanity/url-for'
import { motion, MotionValue, useTransform } from 'framer-motion'
import React, { FC } from 'react'
import { SanityAsset } from 'sanity-codegen'
import * as styles from './styles'

type SectionContentProps = {
  scrollY: MotionValue<number>
  start: number
  windowHeight: number
  windowWidth: number
  multiplier: number
  title: string
  description: string
  iconSource: SanityAsset
  isLast: boolean
}

export const SectionContent: FC<SectionContentProps> = ({
  scrollY,
  start,
  windowHeight,
  windowWidth,
  multiplier,
  title,
  description,
  iconSource,
  isLast,
}) => {
  const startingPoint = start + multiplier * windowHeight
  const endPoint = startingPoint + windowHeight * 0.5
  const isMobile = windowWidth < 768
  const opacity = useTransform(
    scrollY,
    [
      endPoint + windowHeight * 0.1,
      endPoint + windowHeight * (isMobile ? 0.35 : 0.25),
      endPoint + windowHeight * (isMobile ? 0.45 : 0.75),
      endPoint + windowHeight * (isMobile ? 0.7 : 0.95),
    ],
    [0, 1, 1, isLast ? 1 : 0]
  )
  const y = useTransform(
    scrollY,
    [endPoint, endPoint + windowHeight * 0.5, endPoint + windowHeight],
    [80, 0, -80]
  )
  return (
    <motion.div className={styles.usp} style={{ opacity, y: !isLast && y }}>
      <div className={styles.content}>
        <Image
          placeholderSrc={urlFor(iconSource).width(20).url()}
          sources={[urlFor(iconSource).width(160).url()]}
          width={['2.5rem', '3.5rem', '5rem']}
          height={['2.5rem', '3.5rem', '5rem']}
          alt=""
        />
        <div className={styles.text}>
          <Heading variant="h6" as="h2" mt={{ _: '0', sm: '5' }} mb="0">
            {title}
          </Heading>
          <Text variant="bodySmall">{description}</Text>
        </div>
      </div>
    </motion.div>
  )
}
